<span class="snackbar">
    {{message}}
</span>